export default "__VITE_ASSET__7ac39587__"